import { ILocalRepository } from "../../domain/app/ILocalRepository";

export class LocalStoragePlug implements ILocalRepository {
    get<T>(key: string): Promise<T> {
        let item = null;
        const json = localStorage.getItem(key);
        if (json) {
            item = JSON.parse(json);
        }
        return Promise.resolve(item);
    }

    getSync<T>(key: string): T {
        let item = null;
        const json = localStorage.getItem(key);
        if (json) {
            item = JSON.parse(json);
        }
        return item;
    }

    store(key: string, value: any): Promise<any> {
        localStorage.setItem(key, JSON.stringify(value));
        return Promise.resolve(true);
    }
    storeSync(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    delete(key: string): Promise<any> {
        localStorage.removeItem(key);
        return Promise.resolve(true);
    }
}
